import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { useGetSavedSearchQuery } from "marketplace/saved-searches/_api/saved-search-api";
import { savedSearchFailureText } from "marketplace/saved-searches/_views/saved-search-failure-text";
import SavedSearch from "marketplace/saved-searches/saved-search";
import { Navigate, Link as RouterLink, useParams } from "react-router";

const PageContainer = styled("div")(({ theme }) => ({
  margin: "0 auto",
  maxWidth: 900,
  padding: theme.spacing(3, 2),
}));

/**
 * Opens a saved search on the marketplace page, with the filters and sort it was saved with. A new
 * match notification links here, so the link stays right when the search is later changed.
 */
export default function OpenSavedSearchPage() {
  const { savedSearchId } = useParams();
  const { data, error, isLoading } = useGetSavedSearchQuery(
    { savedSearchId: savedSearchId ?? "" },
    { skip: !savedSearchId },
  );

  if (data) return <Navigate replace to={SavedSearch.fromJSON(data).marketplaceUrl} />;

  return (
    <PageContainer>
      {isLoading && <CircularProgress aria-label="Opening saved search" />}
      {(error || !savedSearchId) && (
        <Alert severity="error">
          {savedSearchFailureText(error, "Couldn't open the saved search. Please try again.", true)}{" "}
          <Link component={RouterLink} to="/marketplace/saved-searches">
            See your saved searches
          </Link>
        </Alert>
      )}
    </PageContainer>
  );
}
